export enum CertificationMasterSectionEnum{
    NutrientApplicationRate = 1,
    NutrientApplicationPlacement = 2,
    InFieldManagement = 3,
    StructuralPractices = 4
}